var React = require('react');

function AddCircleFull (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M18.333 10c0 4.603-3.73 8.334-8.333 8.334S1.667 14.603 1.667 10c0-4.602 3.73-8.333 8.333-8.333 4.602 0 8.333 3.731 8.333 8.333zm-9.166-.833V5h1.666v4.167H15v1.667h-4.167V15H9.166v-4.166H5V9.167h4.166z","clipRule":"evenodd"}));
}

AddCircleFull.defaultProps = {"width":"20","height":"20","fill":"currentColor","viewBox":"0 0 20 20"};

module.exports = AddCircleFull;

AddCircleFull.default = AddCircleFull;
